export default __webpack_public_path__ + "static/media/banner.15404b4f.png";